import { useMemo } from "react";
import { mergeConstructorItemProps } from "../mergeConstructorItemProps.js";
function useMergedConstructorItemProps(item, getDefaultProps = () => ({})) {
  return useMemo(() => mergeConstructorItemProps(item, getDefaultProps()), [getDefaultProps, item]);
}
export {
  useMergedConstructorItemProps
};
